import type { InsertedRecord } from "~/features/compoundRecordComposers/types-upload";
import type { CompoundRecordComposerCsvRow } from "~/features/compoundRecordComposers/utils";

type SuccessfulComposer = {
  id: string;
  mainCandidateId: string;
  compoundCandidateId: string;
  note?: string | null;
};

export function toInsertedRecordFromSuccess(
  item: SuccessfulComposer,
  csvData: CompoundRecordComposerCsvRow[],
): InsertedRecord {
  return {
    recordType: "",
    categoryId: "",
    recordIds: [],
    properties: {
      mainCandidateId: item.mainCandidateId,
      compoundCandidateId: item.compoundCandidateId,
      decision: csvData.find(
        (row) => row.mainCandidateId === item.mainCandidateId && row.compoundCandidateId === item.compoundCandidateId,
      )?.decision,
      memo: item.note || undefined,
    },
  };
}
